module.exports = __webpack_public_path__ + "static/fonts/Arimo-SemiBold.c170a0a.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/arimo/Arimo-SemiBold.ttf
// module id = 472
// module chunks = 9